// Black ownership and the financial year-end (owner, 2026-10-10). The backend (server.py) checks and
// prints the same: _validate_ownership, level_for, pct, format_year_end.

export const isQse = (slug) => slug.endsWith("-qse");

// A QSE affidavit may only be used at 51% black ownership or more
export const MIN_QSE_BLACK = 51;

// The level ticked in the affidavit's table
export const levelFor = (slug, black) => {
  if (slug.startsWith("specialised")) return black >= 75 ? 1 : black >= 51 ? 2 : 4;
  if (black >= 100) return 1;
  if (black >= 51) return 2; // "More than 51%" / "At least 51%": 51% counts (owner)
  // Both lower rows say "Less than 30%" in the original; owner: 30-50% Level Four, under 30% Level Five
  if (slug.startsWith("construction")) return black >= 30 ? 4 : 5;
  return 4;
};

export const LEVEL_NAMES = { 1: "Level One", 2: "Level Two", 4: "Level Four", 5: "Level Five" };

export const round2 = (v) => Math.round(v * 100) / 100;

// 51 -> "51", 33.3 -> "33.3" (no needless decimals)
export const pct = (v) => String(round2(v));

// The three choices offered before the affidavit opens (owner's wording)
export const OPTION_ZERO = "zero";
export const OPTION_FIFTY_ONE = "fifty-one";
export const OPTION_CUSTOM = "custom";

export const ownershipSummary = (o) =>
  `${pct(o.black)}% black (${pct(o.woman)}% black woman owned), ${pct(100 - o.black)}% white`;

// Financial year-end: a month ("YYYY-MM"); the year ends on its last day
export const monthEnd = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m, 0);
};

const pad = (n) => String(n).padStart(2, "0");

// Owner: the latest February year-end that has passed
export const latestFebruaryYearEnd = (today = new Date()) => {
  const y = today.getFullYear();
  return today > new Date(y, 2, 0, 23, 59, 59) ? `${y}-02` : `${y - 1}-02`;
};

// The affidavit's own format where it asks for one (YYYY/MM/DD), else DD/MM/YYYY (owner)
export const formatYearEnd = (ym, format) => {
  const d = monthEnd(ym);
  const [dd, mm, yyyy] = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()];
  return format === "YYYY/MM/DD" ? `${yyyy}/${mm}/${dd}` : `${dd}/${mm}/${yyyy}`;
};

// Months that can be chosen: those that have ended, up to 10 years back (backend: _validate_year_end)
export const yearEndChoices = (today = new Date()) => {
  const out = [];
  for (let y = today.getFullYear(); y >= today.getFullYear() - 10; y -= 1) {
    for (let m = 12; m >= 1; m -= 1) {
      const ym = `${y}-${pad(m)}`;
      if (monthEnd(ym) < new Date(today.getFullYear(), today.getMonth(), today.getDate())) out.push(ym);
    }
  }
  return out;
};
